import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";

// Users Redux States
import {
  GET_USERS,
  GET_USER,
  CREATE_USER,
  EDIT_USER,
  EDIT_PASSWORD,
  ACTIVATE_USER,
  GET_USERS_FORM,
  GET_USER_SUMMARY_SETTINGS,
} from "./actionTypes";
import {
  setUsers,
  apiError,
  setUser,
  createUserSuccess,
  editUserSuccess,
  editPasswordSuccess,
  activateUserSuccess,
  setUsersForm,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getUsers({
  payload: { page, qnt, name, email, externalId, filters },
}) {
  try {
    const response = yield call(
      axios.get,
      `/user?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (email ? `&email=${email}` : "") +
        (externalId ? `&externalId=${externalId}` : "") +
        (filters?.status !== (null || undefined)
          ? `&status=${filters.status}`
          : "") +
        (filters?.skills?.length > 0 ? `&skills=${filters.skills}` : "") +
        (filters?.groups?.length > 0 ? `&groups=${filters.groups}` : "") +
        (filters?.profiles?.length > 0 ? `&profiles=${filters.profiles}` : "") +
        (filters?.extra?.length > 0 ? `&extras=` + filters.extra : "") +
        (filters?.name ? `&filterName=${filters.name}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setUsers(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createUser({ payload: { newUserValues } }) {
  try {
    const response = yield call(axios.post, "/user", newUserValues);
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      let message = response.data.message;
      yield put(createUserSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getUser({ payload: { idUser, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/user?${
        (idUser ? `&id=${idUser}` : "") + (isForm ? `&form=${isForm}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setUser(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editUser({ payload: { idUser, newUserValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/user${idUser ? `?id=${idUser}` : ""}`,
      newUserValues
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(editUserSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* editPassword({ payload: { idUser, password } }) {
  try {
    const response = yield call(axios.post, `/user/password-change`, {
      idUser,
      password,
    });
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(editPasswordSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* activateUser({ payload: { idUser, active } }) {
  try {
    const response = yield call(
      axios.patch,
      `/user/activate${idUser ? `?id=${idUser}` : ""}`,
      active
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(activateUserSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getUsersForm() {
  try {
    const response = yield call(axios.get, `/user?form=true`);
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      yield put(setUsersForm(response.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchGetUserFrom() {
  yield takeEvery(GET_USERS_FORM, getUsersForm);
}
export function* watchUser() {
  yield takeEvery(GET_USERS, getUsers);
}
export function* watchCreateUser() {
  yield takeEvery(CREATE_USER, createUser);
}
export function* watchGetUser() {
  yield takeEvery(GET_USER, getUser);
}
export function* watchGetUserSummarySettings() {
  yield takeLatest(GET_USER_SUMMARY_SETTINGS, getUser);
}
export function* watchEditUser() {
  yield takeEvery(EDIT_USER, editUser);
}
export function* watchEditPassword() {
  yield takeEvery(EDIT_PASSWORD, editPassword);
}
export function* watchActivateUser() {
  yield takeEvery(ACTIVATE_USER, activateUser);
}
function* authSaga() {
  yield all([
    fork(watchUser),
    fork(watchGetUser),
    fork(watchGetUserSummarySettings),
    fork(watchCreateUser),
    fork(watchEditUser),
    fork(watchEditPassword),
    fork(watchActivateUser),
    fork(watchGetUserFrom),
  ]);
}

export default authSaga;
